module.exports = __webpack_public_path__ + "static/media/pawritten-bold.ffc04a02.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten-bold.ttf
// module id = ./src/assets/fonts/pawritten-bold.ttf
// module chunks = 6